<script>
	import { navigate  } from 'svelte-routing'
    import { EditCheck } from '../../script/handle/write'
    import { GetContentsList } from '../../script/handle/list'

    export let Page, Pagination
    let maxPagination = 1
    $:if(Pagination <= 5) { maxPagination = Pagination }
        else if(Page <= 3) { maxPagination = 5}
        else if((Number(Page)+2) >= Pagination) { maxPagination = Pagination }
        else { maxPagination = Number(Page) + 2}

    function onCreate() {
        EditCheck.set(false)
        navigate("/create");
    }

    async function onPageClick(_page) {
        await GetContentsList(_page)
        navigate("/list/" + _page);
    }
</script>

<div class="paging">
    <div class="list">
        <button on:click={() => onPageClick(1)}>«</button>

        {#each Array(maxPagination) as _, i}
            {#if (maxPagination - 5 ) <= i}
                <button
                    class:active={Page == (i+1)}
                    on:click={() => onPageClick(i+1)}
                >
                    {(i+1)}
                </button>
            {/if}
        {/each}

        <button on:click={() => onPageClick(Pagination)}>»</button>
    </div>

    <button class='create' on:click={onCreate}>
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path class='bg' opacity="0.5" fill-rule="evenodd" clip-rule="evenodd" d="M1.97491 48.3857V14.3851L3.3158e-05 12.3063V4.85226H0V0H19.1537L21.2327 1.9751H48.3855V36.0624L49.9353 37.6937V45.1477H49.9353V50H30.7816L29.0823 48.3857H1.97491Z" fill="#7A67FF"/>
            <g clip-path="url(#clip0_389_3471)">
            <path d="M20.0707 35.7198C19.9735 35.8175 19.8545 35.8907 19.7245 35.9298L15.7067 37.1724L12.7662 38.0817C12.4832 38.1696 12.2196 38.0903 12.0472 37.9182C11.8759 37.7461 11.7969 37.48 11.8844 37.1956L12.7893 34.2405L14.0257 30.2027C14.0658 30.0733 14.1374 29.9524 14.2346 29.8548L31.9104 12.0948C32.2177 11.786 32.6938 11.7652 32.9744 12.0484L37.7902 16.8881C38.0707 17.1701 38.0501 17.6498 37.744 17.9574L20.0707 35.7198Z" fill="white"/>
            </g>
            <path d="M38.323 36.1326H22.6379C22.0932 36.1326 21.6517 36.5763 21.6517 37.1237C21.6517 37.6711 22.0932 38.1149 22.6379 38.1149H38.323C38.8677 38.1149 39.3092 37.6711 39.3092 37.1237C39.3092 36.5763 38.8677 36.1326 38.323 36.1326Z" fill="white"/>
            <mask id="path-4-inside-1_389_3471" fill="white">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.97491 48.3854V14.3851L3.3158e-05 12.3063V4.85226H0V0H19.1537L21.2325 1.97485H48.3855V36.0624L49.9352 37.6937V45.1477H49.9353V50H30.7816L29.0821 48.3854H1.97491Z"/>
            </mask>
            <path d="M1.97491 14.3851H2.97491V13.9858L2.69991 13.6963L1.97491 14.3851ZM1.97491 48.3854H0.974915V49.3854H1.97491V48.3854ZM3.3158e-05 12.3063H-0.999967V12.7055L-0.724966 12.995L3.3158e-05 12.3063ZM3.3158e-05 4.85226H1.00003V3.85226H3.3158e-05V4.85226ZM0 4.85226H-1V5.85226H0V4.85226ZM0 0V-1H-1V0H0ZM19.1537 0L19.8424 -0.724999L19.5529 -1H19.1537V0ZM21.2325 1.97485L20.5437 2.69985L20.8332 2.97485H21.2325V1.97485ZM48.3855 1.97485H49.3855V0.974854H48.3855V1.97485ZM48.3855 36.0624H47.3855V36.4617L47.6605 36.7512L48.3855 36.0624ZM49.9352 37.6937H50.9352V37.2945L50.6602 37.005L49.9352 37.6937ZM49.9352 45.1477H48.9352V46.1477H49.9352V45.1477ZM49.9353 45.1477H50.9353V44.1477H49.9353V45.1477ZM49.9353 50V51H50.9353V50H49.9353ZM30.7816 50L30.0929 50.725L30.3823 51H30.7816V50ZM29.0821 48.3854L29.7708 47.6604L29.4813 47.3854H29.0821V48.3854ZM0.974915 14.3851V48.3854H2.97491V14.3851H0.974915ZM-0.724966 12.995L1.24992 15.0738L2.69991 13.6963L0.725033 11.6175L-0.724966 12.995ZM-0.999967 4.85226V12.3063H1.00003V4.85226H-0.999967ZM0 5.85226H3.3158e-05V3.85226H0V5.85226ZM-1 0V4.85226H1V0H-1ZM19.1537 -1H0V1H19.1537V-1ZM21.9212 1.24985L19.8424 -0.724999L18.4649 0.724999L20.5437 2.69985L21.9212 1.24985ZM48.3855 0.974854H21.2325V2.97485H48.3855V0.974854ZM49.3855 36.0624V1.97485H47.3855V36.0624H49.3855ZM50.6602 37.005L49.1105 35.3737L47.6605 36.7512L49.2102 38.3825L50.6602 37.005ZM50.9352 45.1477V37.6937H48.9352V45.1477H50.9352ZM49.9353 44.1477H49.9352V46.1477H49.9353V44.1477ZM50.9353 50V45.1477H48.9353V50H50.9353ZM30.7816 51H49.9353V49H30.7816V51ZM28.3933 49.1104L30.0929 50.725L31.4704 49.275L29.7708 47.6604L28.3933 49.1104ZM1.97491 49.3854H29.0821V47.3854H1.97491V49.3854Z" fill="#7A67FF" mask="url(#path-4-inside-1_389_3471)"/>
            <defs>
            <clipPath id="clip0_389_3471">
            <rect width="26.2701" height="26.2701" fill="white" transform="translate(11.8495 11.8496)"/>
            </clipPath>
            </defs>
        </svg>
    </button>
</div>

<style lang="scss">
    .paging {
        width: calc(100%);
        height: fit-content;
        padding-top: 80px;
        padding-bottom: 50px;
        text-align: center;  
        position: relative;

        .list {
            height: 100%;

            button {
                all: unset;
                width: 22px;
                height: 22px;
                margin-right: 4px;
                border-radius: 50%;
                color: $cl3;
                font-size: 12px;
                font-family: aggro;
                text-align: center;

                &.active {
                    color: $cl2;
                    cursor: default;
                }
                &:hover:not(.active) {
                    background: $cl3;
                    color: $cl2;
                    cursor: pointer;
                }
            }
        }

        .create {
            all: unset;
            cursor: pointer;

            position: absolute;
            top: 30px;
            right: 30px;

            svg {
                position: relative;

                &:hover {
                    .bg {
                        opacity: 1.0;
                    }
                }
            }

        }
    }
</style>